import React from "react";

import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
} from "chart.js";
import annotationPlugin from "chartjs-plugin-annotation";
import { Line } from "react-chartjs-2";

ChartJS.register(
  CategoryScale,
  LinearScale,
  PointElement,
  LineElement,
  Title,
  Tooltip,
  Legend,
  annotationPlugin
);

export const PriceGraph = ({ data }) => {
  if (data) {
    const priceData = data?.map((scan) => scan.price);

    // Calculate the average price and max
    const average = priceData.reduce((a, b) => a + b, 0) / priceData.length;
    const max = Math.max(...priceData);

    // Calculate dynamic yAdjust to avoid label being cut off
    const percentFromTop = ((max - average) / max) * 100;
    const yAdjust = percentFromTop < 15 ? 10 : -15;

    return (
      <Line
        options={{
          responsive: true,
          maintainAspectRatio: true,
          plugins: {
            legend: {
              display: false,
            },
            tooltip: {
              backgroundColor: 'rgba(30, 41, 59, 0.95)',
              padding: 12,
              borderColor: 'rgba(51, 65, 85, 1)',
              borderWidth: 1,
              titleColor: '#fff',
              bodyColor: '#fff',
              cornerRadius: 8,
            },
            annotation: {
              annotations: {
                averageLine: {
                  type: "line",
                  yMin: average,
                  yMax: average,
                  borderColor: "rgb(249, 115, 22)",
                  borderWidth: 2,
                  borderDash: [5, 5],
                  label: {
                    content: `Moyenne: ${average.toFixed(2)} €`,
                    display: true,
                    position: "end",
                    backgroundColor: "rgba(249, 115, 22, 0.9)",
                    color: "#fff",
                    yAdjust: yAdjust,
                    xAdjust: -150,
                    borderRadius: 6,
                    padding: 6,
                    font: {
                      size: 11,
                      weight: 'bold',
                    },
                  },
                },
              },
            },
          },
          interaction: {
            mode: "index" as const,
            intersect: false,
          },
          scales: {
            x: {
              grid: {
                display: false,
              },
              ticks: {
                color: '#6B7280',
                font: {
                  size: 11,
                },
              },
            },
            y: {
              type: "linear" as const,
              display: true,
              position: "left" as const,
              border: {
                display: false,
              },
              grid: {
                color: 'rgba(0, 0, 0, 0.05)',
                drawTicks: false,
              },
              ticks: {
                color: '#6B7280',
                font: {
                  size: 11,
                },
                padding: 8,
                callback: function (value) {
                  return Number.isInteger(value) ? value + " €" : null;
                },
              },
            },
          },
        }}
        data={{
          labels: data?.map((scan) => {
            let date = new Date(scan.createdAt);

            const joursSemaine = [
              "dim",
              "lun",
              "mar",
              "mer",
              "jeu",
              "ven",
              "sam",
            ];

            let jourSemaine = joursSemaine[date.getDay()];
            let jour = date.getDate().toString().padStart(2, "0");
            let mois = (date.getMonth() + 1).toString().padStart(2, "0");

            return `${jourSemaine} ${jour}/${mois}`;
          }),
          datasets: [
            {
              label: "Prix",
              data: priceData,
              borderColor: "rgb(249, 115, 22)",
              backgroundColor: "rgba(249, 115, 22, 0.1)",
              tension: 0.4,
              borderWidth: 2,
              pointRadius: 4,
              pointBackgroundColor: "rgb(249, 115, 22)",
              pointBorderColor: "#fff",
              pointBorderWidth: 2,
              pointHoverRadius: 6,
              pointHoverBackgroundColor: "rgb(249, 115, 22)",
              pointHoverBorderColor: "#fff",
              fill: true,
              yAxisID: "y",
            },
          ],
        }}
      />
    );
  }

  return null;
};
